import {
  IEntity,
  ISearchParams,
  SortByEnum,
  SortOrderEnum,
} from '../entity-data/entity-data.data';
import { ClientReference } from '../tracked-time-data/models/client-reference.model';

export const APPOINTMENT_LIST_SEARCH_PARAMS_KEY =
  'appointment_list_search_params';
export const ALL_YEARS = -1;
export const DEFAULT_SEARCH_PARAMS: ISearchParams = Object.freeze({
  sort_by: SortByEnum.start_date,
  sort_order: SortOrderEnum.desc,
});
export const DEFAULT_SCHEDULE_PARAMS: ISearchParams = Object.freeze({
  sort_by: SortByEnum.start_date,
  sort_order: SortOrderEnum.asc,
});
export const GOOGLE_CALENDAR_URL = 'https://www.google.com/calendar/render';
export const GOOGLE_CALENDAR_ACTION = 'TEMPLATE';

export enum AppointmentFiltersEnum {
  unbilled = 'unbilled',
  billed = 'billed',
}

export interface ITimeEntry extends IEntity {
  billingName: string;
  clientReference: ClientReference;
  startDate: string;
  notes: string;
  duration: number;

  hasValidClient(): boolean;
}
